import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Chapter({ num, label, className = "" }) {
  return (
    <div
      className={`inline-flex items-center gap-3 font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-sky-400 ${className}`}
    >
      <span className="h-1.5 w-1.5 rotate-45 bg-amber-400" />
      {`Chapter ${num} // ${label}`}
    </div>
  );
}
